module.exports = __webpack_public_path__ + "static/media/trial1.5a265961.mp3";